module.exports = __webpack_public_path__ + "img/IMG-20200227-WA0311.6e1a8613.jpg";